var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useState } from 'react';
import debounce from 'lodash/debounce';
import get from "lodash/get";
import classNames from "classnames";
import { publish } from 'conversional-callbacks';
import { Events, TrackingActions, useAppDispatch } from 'conversional-journey';
import { ComponentClass, isDesktop } from "conversional-theme";
import QuestionContainer from './QuestionContainer';
import ImageOptions from './ImageOptions';
import { withConditionals } from "../../utilities/hoc/conditionals";
import { getCommonImageProps } from "./utils";
import QuestionSteps from "./QuestionSteps";
import { renderClasses } from './SingleImageSelectMultistep.styles';
var QuestionSingleImageMultiStepsSelect = function (props) {
    var _a;
    var dispatch = useAppDispatch();
    var trackEvent = function (event) { return dispatch(TrackingActions.event(event)); };
    var _b = useState(null), selected = _b[0], setSelected = _b[1];
    var _c = useState(0), stepIndex = _c[0], setStepIndex = _c[1];
    var _d = useState({}), stepAnswers = _d[0], setStepAnswers = _d[1];
    var styles = renderClasses();
    var _e = props.options, options = _e === void 0 ? [] : _e, componentKey = props.componentKey, multistep = props.multistep;
    useEffect(function () {
        if (multistep)
            setStepIndex(0);
        return function () { return setStepIndex(0); };
    }, []);
    var steps = get(multistep, 'steps', []);
    var currentStep = (multistep ? steps[stepIndex] : null) || {};
    var hasSteps = function () { return (steps || []).length > 0; };
    var isLastStep = function () { return hasSteps() && currentStep && stepIndex + 1 >= steps.length; };
    var getStepIndex = function () { return stepIndex; };
    var onClick = function (value) {
        var _a, _b;
        setSelected(value);
        if (hasSteps() && !isLastStep()) {
            var option = options.find(function (option) { return option.value === value; });
            setStepAnswers(__assign(__assign({}, stepAnswers), (_a = {}, _a[stepIndex] = option, _a)));
            setStepIndex(getStepIndex() + 1);
        }
        var eventName = isLastStep() ? "Question.selected" : "Question.multiSelected";
        publish(eventName, (_b = {}, _b[currentStep.id] = value, _b), componentKey);
        trackEvent(__assign(__assign({}, Events.ANSWER_CLICKED), { label: value || 'undefined' }));
    };
    var debouncedOnClick = useCallback(debounce(onClick, 200), [stepIndex]);
    var getOptions = function () {
        if (!steps)
            return options;
        return currentStep.options || [];
    };
    var changeStep = function (index) {
        for (var i = steps.length; i >= index; i--) {
            delete stepAnswers[i];
        }
        setStepAnswers(stepAnswers);
        setStepIndex(index);
    };
    var renderCards = function (overrideProps) {
        if (overrideProps === void 0) { overrideProps = {}; }
        var imageOptionProps = getCommonImageProps(props);
        return (_jsx(ImageOptions
        // @ts-ignore
        , __assign({ 
            // @ts-ignore
            options: getOptions(), onClick: function (option) { return debouncedOnClick(option.value); }, isSelected: function (option) { return selected === option.value; } }, imageOptionProps, overrideProps)));
    };
    var previousAnswers = Object.keys(stepAnswers).map(function (key) { return (__assign(__assign({}, stepAnswers[key]), { subOptions: undefined, disabled: true })); });
    var previousOptions = renderCards({
        gridConfiguration: {
            item: {
                xs: 12 / previousAnswers.length,
                md: 12 / previousAnswers.length
            },
            container: []
        },
        forceUseCustomGrid: true,
        isSelected: function () { return false; },
        options: previousAnswers
    });
    var previousCardContainerWidth = 100 * (previousAnswers.length / steps.length);
    var currentOptionContainerWidth = 100 / steps.length;
    var previousCards = _jsx("div", { className: styles.previousOptionsContainer, style: { width: "".concat(previousCardContainerWidth, "%"), paddingRight: 10 }, children: previousOptions });
    return (_jsx("div", { children: _jsxs(QuestionContainer, __assign({}, props, { children: [_jsx(QuestionSteps, { multistep: multistep, activeStep: stepIndex, changeStep: changeStep }), _jsxs("div", { className: styles.multiStepQuestionContainer, children: [previousCards, _jsx("div", { className: classNames(styles.currentStepQuestion, (_a = {},
                                _a[ComponentClass({
                                    width: "".concat(currentOptionContainerWidth, "%")
                                })] = isDesktop(),
                                _a)), children: renderCards({
                                forceUseCustomGrid: true,
                                gridConfiguration: {
                                    item: {
                                        xs: 24,
                                    },
                                    container: {
                                        gap: 1
                                    }
                                },
                                flexDirection: "column"
                            }) })] })] })) }));
};
/**
 * This HOC is written by means of transform options into a single array because
 * there is another HOC which needs this options as a prop to compute conditional
 * statement values.
 * */
var transformStepOptions = function (WrappedComponent) {
    return function (props) {
        var options = [];
        var steps = get(props, 'multistep.steps', []);
        steps.forEach(function (step) {
            (step.options || []).forEach(function (option) {
                options.push(__assign(__assign({}, option), { stepId: step.id }));
            });
        });
        var overrideProps = __assign(__assign({}, props), { options: options });
        return _jsx(WrappedComponent, __assign({}, overrideProps));
    };
};
var ComputedStepOptionsComponent = transformStepOptions(QuestionSingleImageMultiStepsSelect);
export default withConditionals(ComputedStepOptionsComponent, {
    conditionalArray: {
        arrayPropName: "options"
    }
});
